const upperFirst = function (str: string): string {
  return str.charAt(0).toUpperCase() + str.substring(1);
};

export default upperFirst;
